import { ShowcaseVueGB } from "../products/ShowcaseVueGB";
//import { CardData } from "fs-pb-vue2/data/cardData";
import { Vue, Watch, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import IConfigService from "fs-pb-vue2/services/config/IConfigService";
import { ShowcaseData } from "fs-pb-vue2/data/showcaseData";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { ConfigStore } from "fs-pb-vue2/store/modules/config";

import { ShowcasePageData } from "fs-pb-vue2/data/showcasePageData";
import { ShowCaseActionType } from "fs-pb-vue2/data/enums/showCaseActionType";
import { ShowCaseNotificationsData } from "fs-pb-vue2/data/showCaseNotificationsData";
import { StateData } from "fs-pb-vue2/data/showCaseNotificationsData";
//import { Inject } from "vue-property-decorator";


export class CardOperationNotificationsVueGB extends Vue {
  //@Inject("$router") private readonly $router!: VueRouter;
  @Prop() params!: any;

  smsNotifications: ShowCaseNotificationsData | null = null;

  stateBlock: any = null;

  smsStateCode: number = 0;

  smsStateName: string = '';

  isTariffEnabled: boolean = false;

  cardId: string = '';

  async mounted() {
    await this.initializeData();
  }

  watchRoute() {
    this.$watch('$route', async () => {
      await this.initializeData();
    });
  }

  async initializeData() {
    if (!this.params || !this.params.card) {
      const storedParams = localStorage.getItem('cardNotificationParams');
      if (storedParams) {
        this.params = JSON.parse(storedParams);
      }
    }

    if (this.params && this.params.card) {
      await this.loadNotificationData();
    } else {
      console.warn('Данные уведомлений не загружены');
    }
  }

  async loadNotificationData(){
    try {
      const showcaseId = this.params.card.Data.cardOperNotifShowcaseId;
      const showcase = this.params.showcaseList.find(
        (item: any) => item.Id === showcaseId
      );
  
      if (showcase) {
        this.smsNotifications = new ShowCaseNotificationsData(showcase);
        this.smsStateCode = this.params.card.Data.SmsStateCode || 0;
        this.smsStateName = this.params.card.Data.SmsStateName;
        this.cardId = this.params.card.Data.Id || ''; 
  
        if (this.smsStateCode != 2 && this.smsNotifications.disabledState) {
          this.stateBlock = this.smsNotifications.disabledState;
        } else {
          this.stateBlock = this.smsNotifications.enabledState;
          this.isTariffEnabled = true;
        }

        const card = this.params.card.Data;

        if (this.stateBlock.tariff) {
          this.stateBlock.tariff = this.formatString(this.stateBlock.tariff, card.TariffName);
        }
    
        if (this.stateBlock.tariffWeb) {
          this.stateBlock.tariffWeb = this.formatString(this.stateBlock.tariffWeb, card.TariffName);
        }
    
        if (this.stateBlock.smsSum) {
          this.stateBlock.smsSum = this.formatString(this.stateBlock.smsSum, card.SmsCommCardSum);
        }
    
        if (this.stateBlock.smsSumWeb) {
          this.stateBlock.smsSumWeb = this.formatString(this.stateBlock.smsSumWeb, card.SmsCommCardSum);
        }
      }
      console.log('showcase', showcase)
    } catch (error) {
      console.error('Ошибка при загрузке данных уведомлений:', error);
    }
    
  }

  callAction(item: StateData): void {
    if (item) {
      const initData = { cardId: this.cardId};
      
      switch (item.actionType) {
        case ShowCaseActionType.Close:
          console.log('Close action');
          break;
        case ShowCaseActionType.OpenLinkInApp:
          this.$router.push({ path: `/${item.actionLink}`, query: initData });
          break;
        case ShowCaseActionType.OpenLinkInBrowser:
          window.open(this.$options.filters.url(item.actionLink), '_blank');
          break;
        case ShowCaseActionType.DownloadFile: {
          const link = document.createElement("a");
          link.href = this.$options.filters.url(item.actionLink);
          link.download = item.actionLink.substring(item.actionLink.lastIndexOf('/'));
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          break;
        }
        default:
          console.log('None action');
          break;
      }
    }
  }

  handleClick = (event: MouseEvent) => {  
    const link = (event.target as HTMLElement).closest("a[data-route='true']");
  
    if (link) {
      event.preventDefault();
  
      if (!this.$router) {
        return;
      }
  
      const href = link.getAttribute("href");
      if (href) {
        this.$router.push(href).catch(err => {
          if (err.name !== "NavigationDuplicated") {
            console.error("Ошибка при навигации:", err);
          }
        });
      }
    }
  };

  formatString(template: string, value: string | number): string {
    return template.replace(/\{0\}/g, value.toString());
  }
  


  async destroyForm(): Promise<void> {
    const { notification, ...rest } = this.$route.query;
    this.$router.replace({ query: { ...rest } });
    this.$emit("hideSelf");
  }

}
